import { useRole } from './useRole';

export function useBakerActionsEnabled() {
  return useRole() === 'baker';
}
